import template from './pyramid-builder.html';
import controller from './pyramid-builder.controller';

let pyramidBuilderComponent = {
  bindings: {
    data: '<',
    isActiveDemo: '<',
    sectionTitle: '@',
    onClosePyramidBuilder: '&',
    pyramidData: '<',
    enableScroll: '@'
  },
  controllerAs: 'vm',
  template,
  controller
};

export default pyramidBuilderComponent;



// WEBPACK FOOTER //
// ./client/app/components/pyramid-builder/pyramid-builder.component.js